import React from "react";

import RefreshIcon from "../../../../../assets/icons/refresh-btn.png";
import Button from "../../components/Button";
import { useTranslation } from "../../../../../hooks";

interface IProps {
  fromCurrency: string;
  toCurrency: string;
  onSwitch: () => void;
}

const FromToCurrencyDirection = (props: IProps) => {
  const { fromCurrency, toCurrency, onSwitch } = props;

  const { t } = useTranslation("createSwapRequest");

  if (!fromCurrency || !toCurrency) {
    return <></>;
  }

  return (
    <div className="from-to-direction">
      {fromCurrency}
      <div className="triangle-right"></div>
      {toCurrency}

      <div className="switch-btn-wrapper">
        <Button onClick={onSwitch}>
          <div className="switch-btn">
            <img src={RefreshIcon} alt="Switch" className="switch-icon" />
            <div className="switch-title">{t("switch")}</div>
          </div>
        </Button>
      </div>
    </div>
  );
};

export default FromToCurrencyDirection;
